import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Hero from '../Components/Hero';
import Features from '../Components/Features';
import HowToPlay from '../Components/HowToPlay';
import Gallery from '../Components/Gallery';
import AboutUs from '../Components/AboutUs';
import Footer from '../Components/Footer';

const Home = () => {
  useEffect(() => {
    // Function to scroll to the section based on the current hash
    const scrollToSection = () => {
      const hash = window.location.hash;
      if (hash) {
        const section = document.querySelector(hash);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };

    // Call scrollToSection on initial load or when the hash changes
    scrollToSection();

    // Listen for hashchange events to handle navigation within the page
    window.addEventListener('hashchange', scrollToSection);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener('hashchange', scrollToSection);
    };
  }, []); // This runs only once on mount

  return (
    <div className="scroll-smooth">
      <Navbar />
      <section id="hero">
        <Hero />
      </section>
      <section id="features">
        <Features />
      </section>
      <section id="how-to-play">
        <HowToPlay />
      </section>
      <section id="gallery">
        <Gallery />
      </section>
      <section id="about-us">
        <AboutUs />
      </section>
      <Footer />
    </div>
  );
};

export default Home;
